import {Component} from '@angular/core';
import {SearchBoxComponent} from "./search-box.component";

@Component({
  selector: 'app-search-box-dialect',
  template: `
    <div class="all-search-box">
      <div class="search-recently-box">
<!--           *ngIf="showGoHistory || showHistotyKeyword">-->

        <!-- div class="label-box">최근 검색 내역</div -->

        <div class="scroll-content scroll-effect over-x">
          <div class="list-box">


            <div class="item-box arrow"
                 [style.visibility]="historyKeyword?.list?.length === 0 ? 'hidden' : 'visible'"
                 *ngIf="keyHistoryKeyword">
              <div class="keyword-box">검색 이력</div>
              <a class="keyword-arrow"></a>
            </div>

            <div class="item-box"
                 *ngFor="let item of historyKeyword?.list; let idx = index"
                 (click)="onHistoryClick($event, item)">
              <div class="keyword-box">{{ item }}</div>
              <a class="keyword-remove-btn"
                 (click)="onHistoryDel($event, idx)"></a>
            </div>

          </div>
        </div>

      </div>

      <article class="total-search-form">
        <div class="search-box tiger {{ cssBear }} {{ top ? 'top' : '' }}">
          <form [formGroup]="searchForm">
            <input #search_box
                   type="text"
                   formControlName="keyword"
                   [placeholder]="GetPlaceholder()"
                   (input)="onInputSearchBox($event)"
                   (keyup)="onKeyUpSearchBox($event, search_box.value)">
          </form>
          <a class="clear-btn"
             *ngIf="search_box.value.length > 0"
             (click)="onPushClearBtn($event, search_box)"></a>
        </div>
      </article>

    </div>
  `,
})
export class SearchBoxDialectComponent extends SearchBoxComponent {

}
